export let navigationMenuButtonLabel = "F4paqd";
export let settingsDividerText = "THawc";
export default {navigationMenuButtonLabel,settingsDividerText};